export default {
  path: 'duck-egg-collections',
  name: 'incubators.duck-egg-collections',
  component: () => import('@/views/admin/incubators/duck-egg-collections/Index'),
}